import { render, staticRenderFns } from "./threeGameView.vue?vue&type=template&id=a120d932"
import script from "./threeGameView.vue?vue&type=script&lang=js"
export * from "./threeGameView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports